/**
 * Define errors here and use these for logging.
 */
export enum ErrorEvent {
  InsertComponentFromDiscoverError = 'InsertComponentFromDiscoverError',
  InsertActivityBlueprintFromDiscoverError = 'InsertActivityBlueprintFromDiscoverError'
}
